import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectState = (state) => state.get('formFormPage') || initialState;

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));
